export default __webpack_public_path__ + "static/media/2.a8b81fe8.jpg";